/*
 * @Author: etong
 * @Date: 2023-12-01 14:58:13
 * @LastEditTime: 2026-01-20 17:54:19
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @Description:
 * @FilePath: \oak\src\utils\versionCheck.js
 * Think first, Program later
 */
import { MessageBox } from 'element-ui'

// 使用 window 级别的全局标记，避免某些场景下模块被重复加载导致标记失效
// 每次路由切换都检查版本，但同一个版本号「只弹一次提示框」
// 同时做防御：如果发现异常情况下被多次触发，则自动熔断版本校验，避免影响正常使用
if (!window.__OAK_VERSION_STATE__) {
  window.__OAK_VERSION_STATE__ = {
    hasShownUpdateDialog: false,
    lastCheckedVersion: null, // 记录上一次检测到的版本号
    checkCount: 0,
    disabled: false
  }
}

const versionCheck = async(to, from, callback) => {
  const state = window.__OAK_VERSION_STATE__

  // 如果版本校验被标记为禁用，则直接放行，避免任何异常情况下影响使用
  if (state.disabled) {
    return callback()
  }

  // 登录回调、重定向等不做版本检查
  if (to.path.includes('redirect') || to.path === '/callback' || to.path === '/fscallback') {
    return callback()
  }

  const whiteList = ['development']
  // if (!process.env.NODE_ENV) return
  if (whiteList.includes(process.env.NODE_ENV)) {
    return callback()
  }

  // 调用次数自增，超过阈值则自动熔断版本校验
  state.checkCount += 1
  const MAX_CHECK_COUNT = 3
  if (state.checkCount > MAX_CHECK_COUNT) {
    state.disabled = true
    return callback()
  }

  try {
    const res = await fetch(`../static/version.json`, {
      method: 'GET',
      mode: 'cors', // 允许发送跨域请求
      // credentials: 'include',
      headers: {
        'Cache-Control': 'no-cache'// 不缓存
      }
    })
    const response = await res.json()

    // 版本不一致
    // console.log('process.env.VERSION', process.env.VERSION)
    // console.log('response.version', response.version)
    // console.log('state.hasShownUpdateDialog', state.hasShownUpdateDialog)
    if (process.env.VERSION !== response.version) {
      // 如果检测到新的版本号（与上次检测到的版本号不同），重置弹窗标志
      // 这样每次发新版本时都能弹窗提示，而不是只弹一次
      const isNewVersion = state.lastCheckedVersion !== response.version
      if (isNewVersion) {
        // 只有检测到真正的新版本时才重置标志
        state.hasShownUpdateDialog = false
        state.lastCheckedVersion = response.version
      }

      // 如果当前版本未弹过更新提示，则弹窗
      if (!state.hasShownUpdateDialog) {
        // 先设置标志为 true，防止在弹窗期间重复触发
        state.hasShownUpdateDialog = true
        MessageBox.confirm(
          '系统已更新，请刷新页面，若有工作未完成可先取消，但请尽快刷新避免对使用造成影响!',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          window.location.reload(true)
          callback()
        }).catch(() => {
          // 用户取消刷新，本次路由仍然放行
          // hasShownUpdateDialog 保持为 true，确保同一版本号不会再反复弹窗
          callback()
        })
      } else {
        // 已经为当前版本弹过窗，直接放行
        callback()
      }
    } else {
      // 版本一致，更新记录的上次检测版本号
      // 注意：不重置 hasShownUpdateDialog，保持用户之前的选择（如果用户点击过取消，应该保持不再弹窗）
      state.lastCheckedVersion = response.version
      callback()
    }
  } catch (e) {
    // 请求异常时，不要卡住路由，直接放行
    // console.error('版本检查失败:', e)
    callback()
  }
}

export default versionCheck

